import { Skeleton } from '@mui/material';

export const LeftNavLinkLoaderList = Array.from({ length: 5 })
  .fill(undefined)
  .map((_, index) => <Skeleton key={index} sx={{ width: `100%`, height: `90px` }} />);
